export default ['visible', 'position', 'scale', 'rotation'];
